module.exports = __webpack_public_path__ + "3b2c3dcd8a4c51f9154cca47cc60ebfc.fbx";